import React, { Component } from 'react';
import classnames from 'classnames';
import { themr } from 'react-css-themr';
import PropTypes from 'prop-types';
import { BUTTON } from 'react-toolbox/lib/identifiers';
import InjectFontIcon from 'react-toolbox/lib/font_icon/FontIcon';
import rippleFactory from 'react-toolbox/lib/ripple/Ripple';
import pure from 'recompose/pure';

const factory = (ripple, FontIcon) => {
    class IconButton extends Component {
        static propTypes = {
            accent: PropTypes.bool,
            children: PropTypes.node,
            className: PropTypes.string,
            fieldId: PropTypes.string,
            disabled: PropTypes.bool,
            href: PropTypes.string,
            icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
            inverse: PropTypes.bool,
            neutral: PropTypes.bool,
            onMouseLeave: PropTypes.func,
            onMouseUp: PropTypes.func,
            primary: PropTypes.bool,
            theme: PropTypes.object,
            type: PropTypes.string,
            count: PropTypes.any
        };

        static defaultProps = {
            accent: false,
            className: '',
            neutral: true,
            primary: false
        };

        handleMouseUp = event => {
            this.refs.button.blur();
            if (this.props.onMouseUp) this.props.onMouseUp(event);
        };

        handleMouseLeave = event => {
            this.refs.button.blur();
            if (this.props.onMouseLeave) this.props.onMouseLeave(event);
        };

        handleClick = event => {
            const { onClick, disabled, fieldId } = this.props;
            if (disabled) {
                return;
            }
            onClick(event, fieldId);
        };

        render() {
            const {
                accent,
                children,
                className,
                href,
                icon,
                inverse,
                neutral,
                primary,
                theme,
                count,
                ...others
            } = this.props;
            const element = href ? 'a' : 'button';
            const level = primary ? 'primary' : accent ? 'accent' : 'neutral';
            const classes = classnames(
                [theme.toggle],
                {
                    [theme[level]]: neutral,
                    [theme.inverse]: inverse
                },
                className
            );

            const event = this.props.disabled ? 'onMouseOut' : 'onMouseLeave';

            const props = {
                ...others,
                href,
                ref: 'button',
                className: classes,
                disabled: this.props.disabled,
                onMouseUp: this.handleMouseUp,
                onClick: this.handleClick,
                /* Using onMouseOut instead of onMouseLeave due to onMouseLeave not triggering for disabled elements
                https://github.com/facebook/react/issues/4251 */
                /* changing onMouseOut to onMouseLeave for enabled elements
                 * becuase it triggers onMouseOut on hover of child. */
                [event]: this.handleMouseLeave,
                'data-react-toolbox': 'button'
            };
            return React.createElement(
                element,
                props,
                icon && count ? (
                    <div className={theme.countBtn}>
                        <FontIcon className={theme.icon} value={icon} />
                        <div className={theme.countWrap}>
                            <div className={theme.count}>{count}</div>
                        </div>
                    </div>
                ) : null,
                icon && !count ? (
                    <FontIcon className={theme.icon} value={icon} />
                ) : null,
                children
            );
        }
    }

    return pure(ripple(IconButton));
};

const IconButton = pure(
    factory(rippleFactory({ centered: true }), InjectFontIcon)
);
export default themr(BUTTON)(IconButton);
export { factory as iconButtonFactory };
export { IconButton };
